import React, { useEffect } from 'react'
import { useSortBy } from 'react-instantsearch'

import cn from 'classnames'

import Button from 'components/button'

import { useTranslate } from 'hooks'

import { INSTANT_SEARCH_INDEX } from 'constants/instantSearch'

import { HitsViewByType } from './constants'
import css from './hits-view-by.module.scss'

export type HitsViewByProps = {
  viewBy: HitsViewByType
  onChangeViewBy: (viewBy: HitsViewByType) => void
}

const HitsViewBy = ({ viewBy, onChangeViewBy }: HitsViewByProps): JSX.Element => {
  const { t } = useTranslate('strapi-search-[...term]')

  const { refine } = useSortBy({
    items: [],
  })

  const isProduct = viewBy === 'PRODUCT'

  useEffect(() => {
    refine(isProduct ? INSTANT_SEARCH_INDEX['variants-from-connector'].name : INSTANT_SEARCH_INDEX.brand.name)
  }, [isProduct, refine])

  const handleOnClick = () => {
    onChangeViewBy(isProduct ? 'BRAND' : 'PRODUCT')
  }

  return (
    <div className={css.container}>
      <span className={css.viewBy}>{t('PageSearch.PageSearch_Filters_view_by')}</span>
      <div className={css.switchWrapper}>
        <Button
          className={cn([css.btnViewBy, isProduct && css.btnLeft])}
          style="rounded"
          color={isProduct ? 'blue' : 'secondary-yellow-1'}
          forceActive={isProduct}
          label={t('PageSearch.PageSearch_Filters_product')}
          onClick={handleOnClick}
          trackName="product_view_by_product_click"
        />
        <Button
          className={cn([css.btnViewBy, !isProduct && css.btnRight])}
          style="rounded"
          color={isProduct ? 'secondary-yellow-1' : 'blue'}
          forceActive={!isProduct}
          label={t('PageSearch.PageSearch_Filters_brand')}
          onClick={handleOnClick}
          trackName="product_view_by_brand_click"
        />
      </div>
    </div>
  )
}

export default HitsViewBy
